/**
 * Facility-scoped BV validation flag from Firestore healthcare_facility config.
 *
 * @module useValidateBvEnabled
 */
import { useSelector } from "react-redux";
import { isHealthFacilityFeatureEnabled } from "../data-model/healthFacility";
import { RootState } from "../redux/store/store";

/**
 * Returns whether BV financial fields are mandatory on EV coverage save/continue
 * for the logged-in user's healthcare facility (`validate_bv` in `feature_config` / facility doc).
 *
 * @returns `true` when BV field validation is enabled for the facility.
 */
export const useValidateBvEnabled = (): boolean =>
  useSelector((state: RootState) =>
    isHealthFacilityFeatureEnabled(
      state.singleHealthFacilityDetails.data,
      "validate_bv",
    ),
  );
